import React from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import { Grid } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Button from '@material-ui/core/Button';
import { linkToQueryDetail } from '../../../../../util/appUtils';
import CardContainer from '../../../../../components/kea/CardContainer';
import { generateAndDownloadCSV } from '../components/analyticsCsv';

const MainSection = ({ queryNoResult, currentShop }) => {
  const localizeMessage = useLocalizedMessage();
  const { isFetching, data, error } = queryNoResult;

  const headCells = [
    {
      id: 'query', numeric: false, label: localizeMessage('analytics.table.query'), sortKey: 'queryText',
    },
    { id: 'users', numeric: true, label: localizeMessage('analytics.table.users') },
    { id: 'total', numeric: true, label: localizeMessage('analytics.table.total') },
  ];

  const prepareRows = (rows) => rows.map((el, i) => ({
    ...el,
    id: `${el.query}-${i}`,
    queryText: el.query,
    query: linkToQueryDetail(currentShop, el.query),
    ctr: (el.ctr * 100).toFixed(2),
  }));

  return (
    <CardContainer
      headerId="search.analytics.queryNoResult.header"
      subheaderId="search.analytics.queryNoResult.subheader"
      styleName="noMargin"
      tableSurface
      isFetching={isFetching}
      error={error}
      actionComponent={(
        <Grid item xs={12} sm={6} md={6} lg={12}>
          <Button startIcon={<CloudDownloadIcon />} onClick={() => generateAndDownloadCSV(headCells, data)}>{localizeMessage('analytics.downloadCsv')}</Button>
        </Grid>
      )}
    >
      <AnalyticTable
        rows={prepareRows(data)}
        headCells={headCells}
        orderById="total"
      />
    </CardContainer>
  );
};

export default MainSection;
